<template>
	<div class="px-5 pt-3 pb-2 mb-5 ResponsiveAudit page-fill">
		<div class="items-center justify-between flex">
			<div class="title flex items-center">
				<h1>CAPA Tasks</h1>
			</div>
			<div class="flex items-center gap-3">
				
				<button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton'">
					<img  v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
					<img v-else src="@/assets/filter.svg" class="filterIcon" />
					Filters
				</button>
			</div>
		</div>
		<div class="mt-3">
			<p class="headerText">
				Manage Corrective and Preventive Action (CAPA) tasks linked to compliance findings. Create, assign, and track tasks to ensure timely resolution, prevent recurrence, and strengthen your organization’s overall compliance and risk posture. 
			</p>
		</div>
        <!-- {{ tableRow }} -->
        <div class="mt-5 table-section">
			<tableData class="flex-1 min-h-0" :tableRowData="tableRow" :headersData="headersTable" :loadData="dataLoading"></tableData>
			<div v-if="toolTipActive">
				<tool-tip :tipText="toolTipText"></tool-tip>
			</div>
		</div>
	</div>
</template>
<style scoped>
.btnPrimaryPadding{
	padding-left : 16px;
	padding-right : 16px;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { required } from '@vuelidate/validators';
import tableData from '@/components/tableData.vue';
import useVuelidate from '@vuelidate/core';
import { mapGetters } from 'vuex';
import { emitter, toast } from '@/main';
import toolTip from '@/components/toolTip.vue'
import moment from 'moment';
import { CLOSED_TASK_STATUSES, isOverdueDate } from '@/utils/dashboardKpi';

export default defineComponent({
	data(): any {
		return { 
			v$: useVuelidate(),
			savedAuditSets: [],
			optionsUserArray: [],
			showFilters: false,
            actionBtn: true,
            allEntities: [],
			dummyList: [],
			tableRow: [],
			allTableRows: [],
			orgUsersList: [],
			teamsList: [],
			optionUserArray:[],
            allTasks:[],
			allFindings:[],
			headersTable:['taskId','action','findingCapaId','department','location','reviewer','dueDate','capastatusCode'],
			toolTipActive:false,
			toolTipText:'',
			optionsForFindingIds:[],
			dataLoading:true,
		};
	},
	components: {
		tableData,
		toolTip
	},
	
	
	methods: {
        async getallEntities() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                this.allEntities = res.data;
            });
        },
		async getAllTeams() {
			this.teamObject = [];
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
				this.teamsList = res.data;
			});
		},
		async getAllFindings() {
		await this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/findings/getall`).then((result: any) => {			
			this.allFindings = result.data;
			for(let i=0;i<this.allFindings.length;i++){
        // if() {
				  this.optionsForFindingIds.push({ _id:this.allFindings[i]._id, findingId: this.allFindings[i].findingId});
        // }
			}
		});	
    },
		async getallUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
				this.orgUsersList = res.data;
			});
		},
		async getAllFindingTasks(){
			this.tableRow = [];
            await this.$http
				.get(`${process.env.VUE_APP_MONITOR_API}/capa/tasks`)
				.then((result: any) => {
					this.allTasks = result.data;
					this.allTasks.forEach((task:any) => {
						if(task){
							let taskReviewer = this.orgUsersList.find((user: any) => {
							return user._id == task.reviewer;
						})
						task.reviewer = taskReviewer != undefined ? taskReviewer.name : 'N/A'
						let taskDepartment = this.teamsList.find((team: any) => {
							return team._id == task.department;
						})
						task.department = taskDepartment != undefined ? taskDepartment.displayName : 'N/A'
						let entity = taskDepartment == undefined || taskDepartment == '' || taskDepartment == null ? 'N/A' : taskDepartment.entityName
						let fingingsMatch=this.optionsForFindingIds.find((finding:any)=>{
							return finding._id==task.linkedFindingId
						})
						task.findingCapaId=fingingsMatch?.findingId!=undefined?fingingsMatch.findingId.toUpperCase():'N/A'
							let Entity:any
							let keysOfObject:any = Object.keys(task)
							if(keysOfObject.includes('location') && task.location!=undefined && task.location!='Global') {								
								Entity = task.location;
							}
							else if(keysOfObject.includes('location') && keysOfObject.includes('entity') && (task.entity != undefined || task.entity != '' || task.entity != null)){
								
								Entity = this.allEntities.find((data:any)=>{return data._id == task.entity}).entityName
							}
							else if(keysOfObject.includes('location') && (task.location != undefined || task.location != '' || task.location != null) && task.location=='Global'){
								if(task.location!='Global'){
									Entity = task.location
								}
								else if(task.location=='Global'){
									Entity = this.allEntities.find((data:any)=>{return data.entityType==1}).entityDisplayName
								}
							} else if(keysOfObject.includes('entity') && (task.entity != undefined || task.entity != '' || task.entity != null)) {

								Entity = this.allEntities.find((data:any)=>{return data._id == task.entity}).entityName
							} else {
								Entity = 'N/A'
							}

							if(Entity != 'Global' && task.location==undefined){
								const matchedEntity = this.allEntities.find((data:any)=>{return data._id == task.entity})
								Entity = matchedEntity ? matchedEntity.entityName : '';

							}
							
						// 	if(task.entitytypecodeid == 20301){
                        //             let primaryEntity: any
                        //             // let entityObj = this.allEntities.find((entity: any)=>{return entity.entityType == 1})
                        //             primaryEntity = 'Global'
                        //             this.tableRow.push({ ...task, 'location': primaryEntity });
                        //         }
                        //    else if(task.entitytypecodeid == 20303){
						// 		// console.log('NOT GLOBAL',task.entity != 'Global',task.entity)
                        //         // task.entity.forEach((locationObj: any) => {
                        //         //     // Create a new object with the original task properties and assign locationObj to the entity key
                        //         //     console.log("locationObj",locationObj)
                        //             let entityObj = this.allEntities.find((entity: any)=>{
						// 				return entity._id == task.entity
						// 			})
                        //             this.tableRow.push({ ...task, 'location': entityObj ? entityObj.entityName : 'N/A' });
                        //         // });
                        //     } else{
						if(task.hasOwnProperty('dueDate') && task.dueDate!=undefined){
							task.dueDate = moment(task.dueDate).format('DD-MM-YYYY')
						}else{
							task.dueDate='N/A'
						}
								
								this.tableRow.push({ ...task, 'location': Entity == undefined || Entity == '' ? 'N/A' : Entity ,'capastatusCode':task.statusCode==undefined||task.statusCode=='N/A'?'':task.statusCode, dueDateRaw: task.endDate || task.dueDate});
							// }
                        
						}
                   });
            });
            this.allTableRows = [...this.tableRow];
            this.applyDashboardKpiFilter();
            
        },
        goToFindingsInfo(obj:any){
            emitter.emit('openDetailsModal', {
				view: 'actionTask',
				title: obj.entityData.action || 'CAPA Task',
				params: { findingId: obj.entityData.linkedFindingId, taskId: obj.entityData._id },
			});
        },
		async refreshAfterDetailsModal() {
			await this.getAllFindingTasks();
		},
		filterOpen() {
			this.showFilters = !this.showFilters;
			if (this.showFilters == true) {
                this.dummyList = this.tableRow;
            } else {
                this.tableRow = this.dummyList;
            }
			emitter.emit('visible', this.showFilters);
		},
        applyDashboardKpiFilter() {
            const kpi = String(this.$route.query.kpi || '');
            if (!kpi) {
                this.tableRow = [...this.allTableRows];
                return;
            }
            this.tableRow = this.allTableRows.filter((row: any) => {
                const status = Number(row.capastatusCode ?? row.statusCode);
                const isOpen = !CLOSED_TASK_STATUSES.includes(status);
                if (kpi === 'openCapas') {
                    return isOpen;
                }
                if (kpi === 'overdueCapas') {
                    return isOpen && isOverdueDate(row.dueDateRaw || row.endDate || row.dueDate);
                }
                return true;
            });
        },
        
	},
	async created() {
		this.dataLoading = true;
		await this.getallUsers();
		await this.getAllTeams();
        await this.getallEntities();
		await this.getAllFindings();
        await this.getAllFindingTasks();
		this.dataLoading = false;
        emitter.off('allFindingsTasks')
		emitter.on('allFindingsTasks',async (actionObj:any)=>{
            this.goToFindingsInfo(actionObj)
		})
		emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {                        
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
 
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        }); 
		emitter.off('detailsModalClosed');
		emitter.on('detailsModalClosed', this.refreshAfterDetailsModal);
    },
	beforeUnmount() {
		emitter.off('detailsModalClosed', this.refreshAfterDetailsModal);
	},
});
</script>
 